import { useQuery } from "@tanstack/vue-query"
import { api } from "@/api"

export type MGTransactionsByMerchantReportQuery = {
  start: string
  end: string
}

type MGTransactionsByMerchantLabel = {
  start: Date
  end: Date
}

type MGTransactionsByMerchantDataset = {
  merchantName: string
  merchantId: string
  data: number[]
}

export type MGTransactionsByMerchantReportResponse = {
  labels: MGTransactionsByMerchantLabel[]
  merchantDatasets: MGTransactionsByMerchantDataset[]
}

const retrieveMGTransactionsByMerchantReport = async (
  query: MGTransactionsByMerchantReportQuery
): Promise<MGTransactionsByMerchantReportResponse> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<MGTransactionsByMerchantReportResponse>
  >("/merchant-group/reports/transactions/by-merchant/", {
    query,
    isMerchantGroup: true,
  })
  return {
    labels: body.labels.map((label) => ({
      start: DateFns.parseISO(label.start),
      end: DateFns.parseISO(label.end),
    })),
    merchantDatasets: body.merchantDatasets,
  }
}

export const useMGTransactionsByMerchantReport = (
  query: MaybeRef<MGTransactionsByMerchantReportQuery>
) =>
  useQuery(
    [
      BASE_MERCHANT_GROUP_TRANSACTIONS_BY_MERCHANT_REPORT_QUERY_KEY,
      query,
    ] as const,
    ({ queryKey: [_name, query_] }) =>
      retrieveMGTransactionsByMerchantReport(unref(query_)),
    { refetchInterval: 60 * 1000 }
  )
